// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ct-wizard-section-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 5rem;
}
.ct-wizard-section-header h3,
.ct-wizard-section-header h5 {
  margin-bottom: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/CatalogTransferWizardHeader/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AACF;AACE;;EAEE,mBAAA;AACJ","sourcesContent":[".ct-wizard-section-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 5rem;\n\n  h3,\n  h5 {\n    margin-bottom: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
